import { getMpAgent } from '@cibo/core'
import { useMutation } from '@tanstack/react-query'

const PATH = '/fields/sendImportMsg'

export const useSendImportMessage = () =>
  useMutation({
    mutationKey: ['sendImportMessage'],
    mutationFn: () => getMpAgent().post(PATH),
  })
